import { buildBlogPostSchema } from './utils';
import { SCHEMA_TYPES } from './schema-types';
var schemaType = SCHEMA_TYPES.BLOG_POST_NEWS_ARTICLE;
var type = 'NewsArticle';
export default buildBlogPostSchema({ schemaType: schemaType, type: type });
